import { getDeadline } from '@/utils/bot'
import { BigNumber } from '@ethersproject/bignumber'
import { zeroAddress } from '@/config'
import { useSelector } from 'react-redux'
import { spenToken, token } from '@/store'

export default function useFuncName() {
    const _spenToken = useSelector(spenToken)
    const _token = useSelector(token)

    const getFuncName = (wallet, WETHToken) => {
        let buyArg = []
        let buyPaths = []
        let buyFuncName = ''
        let sellArg = []
        let sellPaths = []
        let sellFuncName = ''
        let isSpenMianToken = true
        const to = wallet.address
        const deadline = getDeadline()
        if (BigNumber.from(_spenToken?.address).eq(BigNumber.from(WETHToken)) || BigNumber.from(_spenToken?.address).eq(BigNumber.from(zeroAddress))) {
            // 支持收税的根据精确的ETH交换尽量多的token
            buyFuncName = 'swapExactETHForTokensSupportingFeeOnTransferTokens'
            // 支持收税的根据精确的token交换尽量多的ETH
            sellFuncName = 'swapExactTokensForETHSupportingFeeOnTransferTokens'
        } else {
            isSpenMianToken = false
            //支持收税的根据精确的token交换尽量多的token
            buyFuncName = 'swapExactTokensForTokensSupportingFeeOnTransferTokens'
            sellFuncName = 'swapExactTokensForTokensSupportingFeeOnTransferTokens'
        }
      
        buyPaths = [_spenToken?.address, _token?.address]
        sellPaths = [_token?.address, _spenToken?.address]
     
        buyArg = [0, buyPaths, to, deadline]
        sellArg = [0, sellPaths, to, deadline]
        return { buyArg, buyPaths, buyFuncName, sellArg, sellPaths, sellFuncName, isSpenMianToken }
    }
    return getFuncName
}
